// extracted by mini-css-extract-plugin
module.exports = {"confirmationContainer":"style_confirmationContainer__U8fZK","logo":"style_logo__biGbQ"};